import { useSelector } from "react-redux"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { API_BANKS_PERMISSION_URL } from "../constants"
import { RootState } from "../../store/store"
import { GET_PERMISSIONS_BANK_LIST_QUERY_KEY } from "./usePermissionBankList"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"

export async function deleteBank(
  bankId: string | undefined,
  token: string | null,
) {
  const response = await axios(`${API_BANKS_PERMISSION_URL}/${bankId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })

  if (checkIsFailure(response.status)) {
    throw new Error(
      `Ошибка при запросе данных: ${response.status} - ${response.statusText}`,
    )
  }

  return {}
}

export const useDeleteBankPermission = () => {
  const token = useSelector((state: RootState) => state.auth.token)
  const queryClient = useQueryClient()

  return useMutation<null, any, string>({
    mutationFn: async (req) => {
      await deleteBank(req, token)
      return null
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_PERMISSIONS_BANK_LIST_QUERY_KEY],
      })
    },
  })
}
